export * from './wait-demo.component';
